export class UpdateCurrentUserProfileRequest {
  image_url: string|null;
  username: string;
  birthdate: string;
  about: string;

  constructor(image_url: string|null, username: string, birthdate: string, about: string) {
    this.image_url = image_url;
    this.username = username;
    this.birthdate = birthdate;
    this.about = about;
  }
}
